<div class="flex w-full flex-nowrap items-end gap-2">
  <textbox
    class="w-1/3"
    [control]="form.get('degrees')"
    unit="°"
    [label]="label()"
    type="number"
    [placeholder]="type() === 'lat' ? '0 - 89' : '0 - 179'"
    [required]="requiredSignal()"
    (keydown)="preventInvalidDecimalInput($event, type() === 'lat' ? 89 : 179)"
    (textChange)="updateCoordinates()" />
  <textbox
    [label]="' '"
    class="w-2/3"
    [control]="form.get('minutes')"
    [hasButtonSuffix]="true"
    type="number"
    [decimal]="4"
    [placeholder]="'0.0000'"
    [matSuffixActive]="true"
    (keydown)="preventInvalidDecimalInput($event, 59.9999)"
    (suffixClick)="onSuffixChange()"
    [actionSuffixButtonLabel]="form.get('direction').value"
    (textChange)="updateCoordinates()">
  </textbox>
</div>
@if (hintLabel && hint) {
  <p class="-mt-1 text-sm text-gray-500">
    <span>{{ hintLabel() }}</span>
    <span class="font-bold">{{ hint() }}</span>
  </p>
}
